<template>
  <section id="oh4nvYyqLLXPHlteaBepbTEO8xTQ2tRCN0oc3ztR6R0=" class="artikel_area pt-120 pb-100">
    <div class="container">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Artikel & Berita
            </h4>
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              <i style="color: black; font-size: smaller"
                >Informasi Artikel & Berita Terkini</i
              >
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->

      <!-- START CONTENT -->
      <div class="row">
        <!-- START SUB ARTIKEL -->
        <div class="col-lg-6">
          <div
            class="zoom single_blog blog_2 d-sm-flex mt-8 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.2s"
            v-for="(artikel, index) in artikels"
            :key="index"
            @click="setActiveArtikel(artikel, index)"
            :class="[lastIndex == index ? 'card-grey' : 'card-only']"
          >
            <div class="blog_content media-body mt-10 mb-10">
                <h1 class="label_blog_title">
                  <a class="two-line-overflow"
                    :style="[
                      lastIndex == index
                        ? {
                            color: '#F06A25',
                          }
                        : {},
                    ]">
                    {{ artikel.judul }}
                  </a>
                </h1>
                <div class="label_artikel_title col-sm-12">
                  <p>
                    &nbsp;
                    <span
                      ><i class="lni lni-eye"></i>
                      {{ artikel.visitor_count }}</span
                    >
                    &nbsp;
                    &nbsp;
                    <span><i class="lni lni-calendar"></i>
                      {{ artikel.waktu_buat }}</span>
                    &nbsp;
                  </p>
                </div>
            </div>
          </div>
          <div class="single_form text-center">
            <!-- <router-link class="nav-link" to="/artikelView">Lihat Semua Artikel</router-link> -->
            <router-link
              to="/_art"
              @click="showArtikel = true;"
              class="button-custom wow fadeInUp"
              style="display: block; margin: auto"
              data-wow-duration="2.0s"
              data-wow-delay="0.5s"
              >Lihat Semua Artikel</router-link
            >
          </div>
        </div>
        <!-- END SUB ARTIKEL -->

        <!-- START ARTIKEL UTAMA -->
        <div class="col-lg-6">
          <div class="row">
            <div
              v-if="currentArtikel"
              class="single_blog mt-10 wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              <div class="blog_content">
                <!-- START TITLE -->
                <h5>
                  <span class="more" href="#" @click="goToDetailArtikel(currentArtikel.id)" style="color:black">
                    {{ currentArtikel.judul }}
                  </span>
                </h5>
                <!-- END TITLE -->
                <br />
                <div v-if="currentArtikel.image_source">
                  <!-- START IMAGES -->
                  <div
                    class="blog_image mb-20"
                    v-html="currentArtikel.image_source"
                  ></div>
                  <!-- END IMAGES -->
                </div>
                <!-- START ISI -->
                <p v-html="currentArtikel.intro"></p>
                <span class="more" v-if="currentArtikel" href="#" @click="goToDetailArtikel(currentArtikel.id)"
                  >Lihat Selengkapnya..</span
                >
                <!-- END ISI -->
              </div>
            </div>
          </div>
        </div>
        <!-- END ARTIKEL UTAMA -->
      </div>
      <!-- END CONTENT -->
    </div>
  </section>
</template>

<script>
import ArtikelDataService from "../services/ArtikelDataService";
export default {
  name: "artikel-list",
  emits:["openArtikelChild"],
  props: {
    visibleArtikel: Boolean,
  },
  data() {
    return {
      artikels: [],
      currentArtikel: null,
      currentIndex: -1,
      id: "",
      isOrange: false,
      lastIndex: 0,
      bulan: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Des'],
    };
  },
  computed: {
    showArtikel: {
      get() {
        return this.visibleArtikel;
      },
      set(visibleArtikel) {
        this.$emit("openArtikelChild", visibleArtikel);
      },
    },
  },
  methods: {
    getMonthName(month) {
      return this.bulan[month];
    },

    retrieveArtikels() {
      ArtikelDataService.getAll(0,7)
        .then((response) => {
          this.artikels = response.data.data;
          this.currentArtikel = this.artikels[0];
          this.currentIndex = 0;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    refreshList() {
      this.retrieveArtikels();
      this.currentArtikel = null;
      this.currentIndex = -1;
    },
    setActiveArtikel(artikel, index) {
      this.currentArtikel = artikel;
      this.currentIndex = artikel ? index : -1;
      this.lastIndex = index;
    },
    searchId() {
      ArtikelDataService.findById(this.id)
        .then((response) => {
          this.artikels = response.data;
          this.setActiveArtikel(null);
          console.log(response.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
     goToDetailArtikel(id) {
      this.$router.push({ name: 'detail_article', params: { id: id } })
    },
  },
  mounted() {
    this.retrieveArtikels();
  },
};
</script>

<style>
.card-grey {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #f6f8f9 !important;
  background-clip: border-box;
  border-radius: 0.25rem;
}

.card-only {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  border-radius: 0.25rem;
}

.label_artikel_title p {
  color: #777777;
  font-size: 8px;
}

.label_blog_title {
  font-size: 16px;
  margin-top: 2%;
  margin-right: 5px;
}
.single_blog.blog_2 .blog_content p {
  margin-top: 1px;
}

.post-date {
  float: left;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  border-style: solid;
  border-radius: 0.25rem;
  border-color: #f6f8f9;
}

.post-date .day {
  background: white;
  border-radius: 2px 2px 0 0;
  display: block;
  font-size: 18px;
  font-weight: 900;
  padding: 10px;
}

.post-date .month {
  background-color: #e76a25;
  display: block;
  border-radius: 0 0 2px 2px;
  color: #fff;
  font-size: 0.8em;
  line-height: 1.8;
  padding: 1px 10px;
  text-transform: uppercase;
}

.two-line-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color:#000;
}

</style>
